var NoData = "Không có dữ liệu";
var viLang = {
	NoData: NoData
};

export { NoData, viLang as default };
